<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="sampleTestForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="sampleTest" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                sampleTestForm: () => import('../forms/SampleTestForm'),
                sampleTest: () => import('../editViews/SampleTest'),
                headers: [
                    { text: 'Sample', value: 'sampleId', table: 'samples', form: () => import('../forms/SampleForm') },
                    { text: 'Test', value: 'testId', table: 'tests', form: () => import('../forms/TestForm') },
                    { text: 'Lab', value: 'labId', table: 'labs', form: () => import('../forms/LabForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    labs: [],
                    samples: [],
                    tests: [],
                    items: []
                },
                sorting: [
                    { column: "sampleId", direction: "ascending" },
                    { column: "testId", direction: "ascending" },
                    { column: "labId", direction: "ascending" },
                ],
                itemsField: 'sampleTests',
                editPageName: 'sampleTest',
                apiMethod: 'SampleTests',
                claimName: 'SampleTests',
                formTitle: 'Sample Test',
                excelTitle: 'Sample Tests',
                hasEditPage: true,
            }
        },
    };
</script>
